import React,{Component} from 'react';
import './Account.css';
import { Redirect } from 'react-router';


// redux
import { connect } from 'react-redux';

interface Props{
    // redux
    login?:any
}

interface State{
}

class Account extends Component<Props,State>{

    // constructor(props:Props){
    //     super(props);
    //     this.state={
    //     }
    // }
    componentDidMount(){
        window.location.href = '/api/v1/auth/keycloak/account';
    }

    render(){
        return null;
        // return <Redirect to="/api/v1/auth/keycloak/account" />;
    }

};

export default connect((state: any) => {
    return {
        login: state.login,
        notifications: state.notifications,
    }
})(Account);
